import { api, type AuthUser, setToken, setCachedUser, clearAuth } from './client';

interface GoogleAuthResponse {
  user: AuthUser;
  token: string;
}

interface MeResponse {
  user_id: string;
  email: string;
  display_name: string;
  avatar_url?: string;
  role: string;
}

export async function loginWithGoogle(id_token: string): Promise<AuthUser> {
  const res = await api.post<GoogleAuthResponse>('/auth/google', { id_token });
  const { user, token } = res.data!;
  setToken(token);
  setCachedUser(user);
  return user;
}

export async function getMe(): Promise<AuthUser | null> {
  try {
    const res = await api.get<MeResponse>('/auth/me');
    if (!res.data) return null;
    const user: AuthUser = {
      user_id: res.data.user_id,
      email: res.data.email,
      display_name: res.data.display_name,
      avatar_url: res.data.avatar_url,
      role: res.data.role,
    };
    setCachedUser(user);
    return user;
  } catch {
    return null;
  }
}

export async function getGoogleClientId(): Promise<string> {
  const res = await api.get<{ google_client_id: string }>('/config');
  return res.data?.google_client_id || '';
}

export function logout(): void {
  clearAuth();
}
